import type { AlpineComponent } from 'alpinejs';

type SelectProps = {
	name: string;
	options: string[][];
	placeholder?: string;
	initialActiveIndex?: number;
};

export const select = ({
	options,
	name,
	placeholder,
	initialActiveIndex
}: SelectProps): AlpineComponent<SelectProps> => ({
	name: name ?? crypto.randomUUID(),
	options,
	opened: false,
	currentIndex: initialActiveIndex,
	placeholder,

	init() {
		this.dispatch();

		this.$watch('currentIndex', () => {
			this.dispatch();
		});
	},

	dispatch() {
		this.$root.value = this.currentValue;

		this.$dispatch('pmc-custom-select-change', {
			name: this.name,
			value: this.currentValue
		});
	},

	get currentValue() {
		return options.find((item) => item.product_id == this.currentIndex);
	},

	get valueIsValid() {
		return this.currentValue != null;
	},

	displayCurrentValue(cb: (curr: unknown) => string) {
		if (this.valueIsValid) {
			return cb?.(this.currentValue);
		}

		return placeholder || 'Select an option...';
	},

	open() {
		this.opened = true;
	},

	close() {
		if (this.opened) {
			this.$refs.opener.focus();
		}

		this.opened = false;
	},

	toggle() {
		this.opened ? this.close() : this.open();
	},

	select(i: number) {
		this.currentIndex = i;
	},

	focus(el: HTMLInputElement) {
		if (el.checked) {
			// need to wait for DOM apparently
			setTimeout(() => el.focus(), 0);
		}
	},

	onPointerEvent(event: PointerEvent) {
		if (event.pointerType === 'mouse') {
			this.close();
		}
	}
});
